var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FlatList", {
  enumerable: true,
  get: function get() {
    return _Flatlist.default;
  }
});
exports.AnimatedCircle = exports.RefreshControl = exports.LoadingIndicator = exports.CenteringScreen = exports.Column = exports.Row = exports.StyledImage = exports.Image = exports.HyperText = exports.SubHeading = exports.Heading = exports.Title = exports.Text = exports.Clickable = exports.ScrollView = exports.View = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Flatlist = _interopRequireDefault(require("../components/Web/Flatlist"));

var _ImageResizer = _interopRequireDefault(require("../utilities/ImageResizer"));

var _Sport1Bold = _interopRequireDefault(require("./styles/fonts/Sport1-Bold.ttf"));

var _Sport1Regular = _interopRequireDefault(require("./styles/fonts/Sport1-Regular.ttf"));

var _fontello = _interopRequireDefault(require("./styles/fonts/fontello.ttf"));

var _css = require("./css");

var _keyframes = require("./keyframes");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/elements/Basic.js";

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    ", ";\n    &::before {\n        content: '';\n        display: block;\n        margin: 0 auto;\n        width: 15%;\n        height: 15%;\n        background-color: #333;\n        border-radius: 100%;\n        ", ";\n    }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", " height: 80px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    /* Our custom short-hand styles */\n    ", " ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    /* Our custom short-hand styles */\n    ", " ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-decoration: none;\n    ", " ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    /* Our custom short-hand styles */\n    ", " ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  @font-face {\n    font-family: 'Sport1-Bold';\n    src: url(", ");\n  }\n  @font-face {\n    font-family: 'Sport1-Regular';\n    src: url(", ");\n  }\n  @font-face {\n    font-family: 'fontello';\n    src: url(", ");\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var reshapeHostRegex = /^(https:\/\/(stage-)*?(oz|reshape)+\.sport1\.de).*/;
(0, _styledComponents.injectGlobal)(_templateObject(), _Sport1Bold.default, _Sport1Regular.default, _fontello.default);

var View = _styledComponents.default.div(_templateObject2(), _css.view, _css.webView);

exports.View = View;
var ScrollView = View.extend(_templateObject3());
exports.ScrollView = ScrollView;
View.defaultProps = {
  row: false,
  column: false,
  evenly: false
};

var Clickable = _styledComponents.default.a(_templateObject4(), _css.view, _css.webView);

exports.Clickable = Clickable;

var Text = _styledComponents.default.span(_templateObject5(), _css.text, _css.webText);

exports.Text = Text;
var Title = Text.withComponent('h1');
exports.Title = Title;
var Heading = Text.withComponent('h2');
exports.Heading = Heading;
var SubHeading = Text.withComponent('h3');
exports.SubHeading = SubHeading;

var HyperText = _styledComponents.default.a(_templateObject6(), _css.text, _css.webText);

exports.HyperText = HyperText;
Text.defaultProps = {
  m: 0,
  display: 'inline',
  bold: false,
  fontWeight: 'normal',
  alignRight: false,
  grow: false,
  center: false,
  size: 'medium',
  color: 'font.main'
};
HyperText.defaultProps = {
  bold: false,
  alignRight: false,
  grow: false,
  center: false,
  size: 'medium',
  color: 'font.main'
};

var Image = function Image(props) {
  var src = props.src,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      aspectRatio = props.aspectRatio,
      noResize = props.noResize;
  var source = props.source,
      rest = (0, _objectWithoutProperties2.default)(props, ["source"]);
  var width = style.width,
      height = style.height,
      restStyle = (0, _objectWithoutProperties2.default)(style, ["width", "height"]);
  var newSource = '',
      srcSet = '',
      newStyle = {
    width: width,
    height: height
  };

  if (!noResize && src && !src.match(new RegExp('^(/)?(static|webpack)'))) {
    var imageWidth = width || 40;

    if (typeof imageWidth === 'string' && imageWidth.indexOf('%') > 0) {
      imageWidth = parseInt(700 * parseInt(imageWidth) / 100);
    }

    var aspectHeight = aspectRatio ? parseInt(imageWidth / aspectRatio) : 40;
    var imageHeight = height || aspectHeight;

    if (reshapeHostRegex.test(src)) {
      newSource = src.replace(':width', imageWidth).replace(':height', imageHeight);
      srcSet = newSource + " 1x, " + src.replace(':width', imageWidth * 2).replace(':height', imageHeight * 2) + " 2x";
    } else if (/\bsvg\b/.test(src)) {
      newSource = /^(https?:)?\/\//.test(src) ? src : "//" + src;
    } else {
      newSource = new _ImageResizer.default().setImagePath(src).resize(imageWidth, imageHeight).smartCrop(true).buildUrl();
      srcSet = newSource + " 1x, " + new _ImageResizer.default().setImagePath(src).resize(2 * imageWidth, 2 * imageHeight).smartCrop(true).buildUrl() + " 2x";
    }

    newStyle = {
      width: width,
      height: imageHeight
    };
  }

  return _react.default.createElement(StyledImage, (0, _extends2.default)({}, _objectSpread(_objectSpread({}, rest), {}, {
    src: newSource || src,
    srcSet: srcSet,
    style: _objectSpread(_objectSpread({}, newStyle), restStyle)
  }), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 9
    }
  }));
};

exports.Image = Image;

var StyledImage = _styledComponents.default.img(_templateObject7(), _css.image);

exports.StyledImage = StyledImage;
var Row = View.extend(_templateObject8());
exports.Row = Row;
Row.defaultProps = {
  row: true
};
var Column = View.extend(_templateObject9());
exports.Column = Column;
Column.defaultProps = {
  column: true
};
var CenteringScreen = View.extend(_templateObject10(), _css.centering);
exports.CenteringScreen = CenteringScreen;
var LoadingIndicator = View.extend(_templateObject11(), _css.centering);
exports.LoadingIndicator = LoadingIndicator;

var RefreshControl = _styledComponents.default.div(_templateObject12());

exports.RefreshControl = RefreshControl;

var AnimatedCircle = _styledComponents.default.div(_templateObject13(), function (props) {
  return props.rotate && "transform: rotate(" + props.rotate + "deg)";
}, function (props) {
  return props.delay && "animation: " + _keyframes.fadeDelay + " 1.2s ease-in-out " + props.delay + "s infinite both";
});

exports.AnimatedCircle = AnimatedCircle;